import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../../theme';
export const StyledSubmitButtonWrapper = styled('div')`
    /* stylelint-disable unit-allowed-list */
    display: flex;
    flex-direction: column;
    gap: ${({ theme }: { theme: Theme }) => theme.tggSpacing(rem(2), 8)};
    justify-content: center;

    ${({ theme }) => theme.breakpoints.up('desktop')} {
        flex-direction: row-reverse;
        padding: ${({ theme }: { theme: Theme }) =>
            theme.tggSpacing([0, rem(16)], [0, 64])};

        & > button {
            padding: ${({ theme }: { theme: Theme }) =>
                theme.tggSpacing([rem(0.55), rem(2.5)], [2, 10])};
        }
    }
`;
